import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DataTranscriberForm from "../../Forms/DataTranscriberForm/DataTranscriberForm";
import {
  IAppRouteLocation,
  IWorkflowItemStep
} from "../../../common/sharedTypes";
import { completeDataTranscribe } from "./redux-objects/actions";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import { Button, Form, Row, Col } from "react-bootstrap";
import * as documentDownloadService from "../../../services/documentDownloadService";
import { UserInfo } from "../../Login/common/defaults";
import "./datatranscriber.css";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import * as urls from "../../shared/urls";
import { toast } from "react-toastify";
import NotificationTemplateSelector from "../../NotificationTemplate/NotificationTemplateSelector";
import * as optionIds from "../../shared/optionIds";
import CommentsButton from "../../Comments/CommentsButton";
import "./datatranscriber.css";
import CorrespondenceButton from "../../Correspondence/CorrespondenceButton";
import DriverPdfsButton from "../../shared/DriverPdfsButton/DriverPdfsButton";
import InfoButtonBar from "../common/InfoButtonBar";

enum ServiceEndPoints {
  CompletePaperDataTranscribe = "CompletePaperDataTranscribe",
  GetPaperPdf = "GetPaperPdf"
}

export interface IDataTranscribeActionProps {
  completeDataTranscribe?: (
    url: string,
    itemStep: IWorkflowItemStep,
    data: any,
    moveToNextWorkflow: boolean,
    assignNext: boolean
  ) => Promise<any>;
}

interface IDataTranscribeStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  saving: boolean;
}

interface IDataTranscribeProps
  extends IDataTranscribeActionProps,
    IDataTranscribeStateProps {}

class DataTranscribe extends React.Component<IDataTranscribeProps> {
  private workflowController: string = "Workflow";
  transcriberForm = null;
  backgroundSave;
  state = {
    data: {},
    openWorkflowItemStep: this.props.openWorkflowItemStep,
    spdCheckbox: false,
    spdDisabled: false,
    workZoneCheckbox: false,
    workZoneDisabled: false,
    saving: false
  };
  private crashKey: any;

  componentDidMount() {
    if (!this.backgroundSave) {
      this.backgroundSave = setInterval(() => {
        if (this.state.openWorkflowItemStep && !this.state.saving)
          this.handleComplete(null, false, false, false);
      }, 30000);
    }

    this.loadWorkflowItemStep();
  }

  initializeCheckboxes = (openWorkflowItemStep: IWorkflowItemStep) => {
    const spd =
      openWorkflowItemStep.workflowItem.report.keywords
        .propertyDamageIndicator == "Yes" ||
      openWorkflowItemStep.workflowItem.report.keywords
        .propertyDamageIndicator == "yes";
    const workzone =
      this.props.openWorkflowItemStep.workflowItem.report.keywords
        .workZoneIndicator == "Yes" ||
      this.props.openWorkflowItemStep.workflowItem.report.keywords
        .workZoneIndicator == "yes";
    this.setState({
      spdCheckbox: spd,
      spdDisabled: spd,
      workZoneCheckbox: workzone,
      workZoneDisabled: workzone
    });
  };

  loadWorkflowItemStep = () => {
    this.getTranscriberJsonData(this.state.openWorkflowItemStep);
    this.initializeCheckboxes(this.state.openWorkflowItemStep);

    if (
      this.state.openWorkflowItemStep &&
      this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId
    ) {
      this.handleOpenPdf();
    }
  };

  handleOpenPdf = () => {
    documentDownloadService
      .openOnBaseImage(
        null,
        this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId
      )
      .then();
  };
  setSpdCheckbox = () => {
    this.setState({
      spdCheckbox: !this.state.spdCheckbox,
      spdDisabled: true
    });

    this.setStatePropertyDamage();
  };

  setStatePropertyDamage = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(
        urls.SAVE_STATE_PROPERTY_DAMAGE +
          "?workflowItemStepId=" +
          this.state.openWorkflowItemStep.id,
        {
          ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
          propertyDamageIndicator: this.state.spdCheckbox,
          workZoneIndicator: this.state.workZoneCheckbox == true ? "yes" : "no"
        }
      ).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  setWorkZoneCheckbox = () => {
    this.setState({
      workZoneCheckbox: !this.state.workZoneCheckbox,
      workZoneDisabled: true
    });
    this.setWorkZone();
  };

  setWorkZone = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(urls.SAVE_WORK_ZONE_INDICATOR, {
        ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
        workZoneIndicator: this.state.workZoneCheckbox,
        propertyDamageIndicator: this.state.spdCheckbox == true ? "yes" : "no"
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  getTranscriberJsonData = (openWorkflowItemStep: IWorkflowItemStep) => {
    let id;
    if (openWorkflowItemStep != null) {
      id = { id: openWorkflowItemStep.workflowItemId.toString() };
      this.crashKey =
        openWorkflowItemStep.workflowItem.report.keywords &&
        openWorkflowItemStep.workflowItem.report.keywords.crashKey
          ? openWorkflowItemStep.workflowItem.report.keywords.crashKey.toString()
          : "0";
    } else {
      id = "0";
      this.crashKey = "0";
    }

    if (this.crashKey == null) {
      this.crashKey = "No Crash Key Available";
    }

    Api.post(urls.GET_REPORT_JSON, JSON.stringify(id)).then(
      (response: ApiResponse<any>) => {
        if (response.ok) this.setState({ data: response.data || {} });
        else {
          this.setState({ data: {} });
        }
        return response.data;
      }
    );
  };

  async handleComplete(
    event: React.MouseEvent<HTMLElement>,
    assignNext: boolean,
    moveToNextWorkflow: boolean,
    continueNavigation: boolean = true,
    manualSave: boolean = false
  ) {
    if (!this.transcriberForm) {
      // form not loaded yet
      return;
    }

    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.CompletePaperDataTranscribe
    );
    this.setState({saving: true});
    const toastId = continueNavigation || manualSave
      ? toast.info(continueNavigation ? "Completing report..." : "Saving report...", {
        autoClose: false
      })
      : null;

    const formData = this.transcriberForm.getLatestFormData
      ? await this.transcriberForm.getLatestFormData()
      : this.transcriberForm.getFormData();

    if (!formData) {
      this.setState({saving: false});
      if (toastId) {
        toast.dismiss(toastId);
      }
      return;
    }

    this.props
      .completeDataTranscribe(
        uri,
        this.state.openWorkflowItemStep,
        formData,
        moveToNextWorkflow,
        assignNext
      )
        .then((responseData: any) => {
          this.setState({saving: false});
          if (continueNavigation) {
            if (toastId) {
              toast.update(toastId, {
                render: "Completed",
                type: "success",
                autoClose: 3000
              });
            } else {
              toast.success("Completed");
            }

            if (assignNext) {
              console.log("new props maybe", this.props);
              this.setState(
                {
                  openWorkflowItemStep: this.props.openWorkflowItemStep
                },
                () => {
                  this.loadWorkflowItemStep();
                }
              );
            } else this.props.history.push("/DataTranscribeQueue");
          } else {
            if (manualSave) {
              // Re-bind the live form with the server-normalized (whitespace-trimmed)
              // data so the UI reflects the cleaned values without leaving/reopening.
              if (responseData && responseData.reportData) {
                try {
                  const normalizedData = JSON.parse(responseData.reportData);
                  this.setState({ data: normalizedData });
                  if (this.transcriberForm && this.transcriberForm.setFormData) {
                    this.transcriberForm.setFormData(normalizedData);
                  }
                } catch (ex) {
                  console.log("Unable to parse normalized report data", ex);
                }
              }

              if (toastId) {
                toast.update(toastId, {
                  render: "Saved",
                  type: "success",
                  autoClose: 3000
                });
              } else {
                toast.success("Saved");
              }
            }
          }
        })
        .catch((ex) => {
          const message = ex?.problem || ex?.originalError?.message || ex?.message || "Error saving or completing";
          if (toastId) {
            toast.update(toastId, {
              render: message,
              type: "error",
              autoClose: 5000
            });
          } else {
            toast.error(message);
          }
          console.log(ex);
        })
        .finally(() => {
          this.setState({saving: false});
        });
  }

  openPaperReport() {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.GetPaperPdf
    );
    documentDownloadService.paperReport(
      uri,
      this.state.openWorkflowItemStep.workflowItem.report.id
    );
  }

  sendToManagementQueue = () => {
    try {
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.state.openWorkflowItemStep.id
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: "/DataTranscribeQueue"
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  componentWillUnmount() {
    this.backgroundSave = null;
  }

  public render() {
    const allButtons = (
      <React.Fragment>
        <div className="completeAndStartNextButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, true, true)}
            disabled={this.state.saving}
          >
            Complete and Start Next Report
          </Button>
        </div>
        <div className="completeButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, false, true)}
            disabled={this.state.saving}
          >
            Complete
          </Button>
        </div>
        <div className="saveReportButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, false, false, false, true)}
            disabled={this.state.saving}
          >
            Save Report
          </Button>
        </div>
      </React.Fragment>
    );
    return (
      <div>
        <Row>
          <Col>
            <div className="workZoneCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Work Zone"
                  disabled={this.state.workZoneDisabled}
                  checked={this.state.workZoneCheckbox}
                  onChange={this.setWorkZoneCheckbox}
                />
              </Form.Group>
            </div>
            <div className="spdCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="State Property Damage"
                  checked={this.state.spdCheckbox}
                  onChange={this.setSpdCheckbox}
                />
              </Form.Group>
            </div>
          </Col>
          <Col className="justify-content-end">
            {" "}
            <NotificationTemplateSelector
              optionId={optionIds.dataTranscriberOptionId}
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
            />
          </Col>
          <Col xs={2} className="justify-content-end">
            <CommentsButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right"
              placement="left"
            />
            <CorrespondenceButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right mr-10"
            />
          </Col>
        </Row>
        <InfoButtonBar
          report={this.state.openWorkflowItemStep.workflowItem.report}
          handleOpenPdf={this.handleOpenPdf}
          sendToManagementQueue={this.sendToManagementQueue}
        />
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <DataTranscriberForm
          saving={this.state.saving}
          key={this.state.openWorkflowItemStep.id}
          data={this.state.data}
          injectToSidebar={allButtons}
          ref={(el) => (this.transcriberForm = el)}
          formId={this.state.openWorkflowItemStep.workflowStep.formIoFormId}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep: state.DataTranscribeQueue.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  completeDataTranscribe
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataTranscribe)
);
